import PropTypes from 'prop-types'

function NavButtons({ children }) {
  return <div className="navButtons">{children}</div>
}

NavButtons.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf([PropTypes.node]),
  ]),
}

export default NavButtons
